export default __webpack_public_path__ + "boundaries-sample-480-58ef726f632920f2a4ff1c15feac44c7.webp";